export const apiAlive = async (): Promise<boolean> => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}health`);
    return !!response;
  } catch (e) {
    return false;
  }
};
